import { notification } from "antd";
import { log_out } from "../components/top-navbar/top-navbar";
const exclude_path = ["/v4.0/auth"];
class WebWorker {
  onmessage: ((this: Worker, ev: MessageEvent) => any) | null = (): void => {};
  postMessage: Function = (): void => {};
  // // onerror: Function = (): void => { };
  // // onmessageerror: Function = (): void => { };
  terminate: Function = (): void => {};

  constructor(worker: any) {
    const code = worker.toString();
    const blob = new Blob(["(" + code + ")()"], { type: "application/javascript" });
    return new Worker(URL.createObjectURL(blob));
  }
}
interface request_param {
  url: string;
  props: any;
  datacenter_name?: string;
  method?: number;
  body?: any;
  func?: Function;
  warning?: boolean;
}

const http_worker = (): void => {
  const fetch_request = (param: request_param) => {
    const { url, method = 0, body } = param;
    const type = ["GET", "POST", "PUT", "DELETE", "PATCH"][method];
    const init: RequestInit = {
      method: type,
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    };
    if (body) {
      init.body = JSON.stringify(body);
    }
    return fetch(url, init);
  };
  onmessage = (e: MessageEvent) => {
    const params: request_param = e.data;
    fetch_request(params).then((response: Response) => {
      const status = response.status;
      if (typeof response.json === "function") {
        response
          .json()
          .then((json: any) => {
            postMessage({ status, data: json });
          })
          .catch(() => {
            postMessage({ status, data: {} });
          });
      } else {
        postMessage({ status, data: {} });
      }
    });
  };
};
// 按需以对象形式传入参数 url（必填）、method、body
export const worker_fetch = (param: request_param) => {
  // const { func, props, url, warning = true, datacenter_name } = param;
  const { func, props, url, warning = true } = param;
  param.url = window.location.origin + url;
  func && delete param.func;
  props && delete param.props;
  const { formatMessage, history } = props;
  return new Promise((resolve) => {
    const worker = new WebWorker(http_worker);
    worker.onmessage = (e: MessageEvent) => {
      const { data, status } = e.data;
      if (status > 299 && formatMessage && history && warning) {
        if (data.message && data.reason && url.includes("/adddeleterolebinding") && status === 403) {
          notification.error({
            message: data.reason,
            description: data.message,
          });
        }
        // if (401 === status && !exclude_path.includes(url) && !(url.includes("/appBuy/serviceInstances"))) log_out(props);
        if (401 === status && !exclude_path.includes(url) && !(url.includes("/appBuy/serviceInstances"))) log_out({props, env: undefined, history, redirect_url: "/login/sign-in"});
      } else {
        if (func && 200 <= status && 299 >= status) {
          func(data.items || data.resources || data.resource || data);
        }
      }
      resolve(e.data);
      worker.terminate();
    };
    param.func && delete param.func; // 不能传入worker worker不支持function传入
    worker.postMessage(param);
  });
};
